module.exports = __webpack_public_path__ + "static/media/success_icon.95109a5b.svg";